import React from 'react';
import { Mail } from 'lucide-react';
import { SOCIAL } from '../../data/content';

export default function FloatingWhatsApp() {
  return (
    <a
      href={SOCIAL.whatsapp}
      data-testid="floating-contact"
      aria-label="Email Parth"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-teal text-[#0a0a0f] shadow-[0_10px_40px_rgba(0,245,212,0.3)] flex items-center justify-center hover:scale-110 transition-transform"
    >
      <Mail size={22} strokeWidth={2} />
      <span className="absolute inset-0 rounded-full bg-teal animate-ping opacity-20" />
    </a>
  );
}
